import { EventBusKey, useEventBus } from '@vueuse/core'

export const traceIdUpdatedKey: EventBusKey<string> = Symbol('trace-id-updated')
export const openAboutModalKey: EventBusKey<void> = Symbol('open-about-modal')
export const openPreferencesModalKey: EventBusKey<{ tab?: 'preferences' | 'display', scrollTo?: string }> = Symbol('open-preferences-modal')
export const closeAllModalsKey: EventBusKey<void> = Symbol('close-all-modals')

export const eventBus = useEventBus<string>(traceIdUpdatedKey)
export const aboutEventBus = useEventBus<void>(openAboutModalKey)
export const preferencesEventBus = useEventBus<{ tab?: 'preferences' | 'display', scrollTo?: string }>(openPreferencesModalKey)
export const closeAllModalsEventBus = useEventBus<void>(closeAllModalsKey)

export const sharePreviewVisibleKey: EventBusKey<boolean> = Symbol('share-preview-visible')
export const sharePreviewVisibleEventBus = useEventBus<boolean>(sharePreviewVisibleKey)
